import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types';

const URL = '/v2/admin/user-search';

export interface AdminUserSearchResult {
  id: number;
  name: string;
  email: string;
  created: number;
  status: boolean;
  pictureUrl: string;
  firstName: string;
  lastName: string;
  phone: string;
  city: string;
  state: string;
  parent: boolean;
  sitter: boolean;
}

export interface AdminUserSearchParams {
  searchTerm: string;
  userType?: 'parent' | 'sitter' | 'agency' | 'all';
  page?: number;
  limit?: number;
}

class AdminUserSearchService {
  static search(
    params: AdminUserSearchParams,
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<AdminUserSearchResult>> {
    return axios.get(URL, {
      ...config,
      params: {
        ...params,
        ...config?.params,
      },
    });
  }
}

export { AdminUserSearchService };
